const applySelectionToItems = (items, itemsToReset, isSelected) =>
  items.map((item) => {
    if (itemsToReset.includes(item.id)) {
      return {
        ...item,
        isSelected: isSelected === undefined ? !item.isSelected : isSelected,
      };
    }

    return item;
  });

export default applySelectionToItems;
